<div class="container d-flex justify-content-start align-items-stretch">
    <section class="code-editor flex-1" style="height: 70vh">
        <ngx-monaco-editor [options]="editorOptions" [(ngModel)]="code"></ngx-monaco-editor>
    </section>

    <div class="right p-20 flex-1" style="max-height: 100%; overflow-y: auto">
        <div [innerHtml]="code | safeHtml"></div>
    </div>
</div>
